// keep-popover-open-on-datepicker.directive.ts
import { Directive, Host, OnDestroy } from '@angular/core';
import { DatePicker } from 'primeng/datepicker';

@Directive({
  selector: 'p-datepicker[stopOnDateSelectPropagation], p-datePicker[stopOnDateSelectPropagation], p-date-picker[stopOnDateSelectPropagation]',
  standalone: true
})
export class StopOnDateSelectPropagationDirective implements OnDestroy {
  private restore?: () => void;

  constructor(@Host() datePicker: DatePicker) {
    const original = datePicker.onDateSelect.bind(datePicker);

    (datePicker as any).onDateSelect = (event: any, dateMeta: any) => {
      // Stop the date cell click from reaching document listeners (e.g., popover or pStyleClass outside-click handlers)
      try { event?.stopImmediatePropagation?.(); } catch {}
      try { event?.stopPropagation?.(); } catch {}
      return original(event, dateMeta);
    };

    this.restore = () => ((datePicker as any).onDateSelect = original);
  }

  ngOnDestroy(): void {
    try { this.restore?.(); } catch {}
  }
}

